<template>
  <div
    data-testid-app="body"
    data-testid="sharing-layout"
  >
    <slot />
  </div>
</template>
